import { v4 as uuid } from 'uuid';
export const TOKEN_KEY = 'tokenKey';
export const REF_TOKEN_KEY = 'refTokenKey';
export const MAX_WIDTH_OBJ = '400px';
export const MAX_WIDTH_CONTAINER = '550px !important';
export const MAX_WIDTH_CONTAINER_NotImprotant = '550px';
//chace for api==============
// export const APIBASE_URL = 'https://api.app.develop.samiinco.ir';
export const APIBASE_URL = `${process.env.REACT_APP_API_END_POINT}`;
export const ACCOUNT_URL = '/api/Account';
export const EXTERNAL_ACCOUNT_URL = '/api/ExternalAccount';
export const CHEQUE_URL = '/api/cheque';
export const REGISTRATION = '/api/Registration';
export const LOAN = '/api/Loan';
export const INCOME = '/api/Income';
export const RESIDENTIAL = '/api/Residential';
export const INQUIRY = '/api/Inquiry';
export const GUARANTOR = '/api/Guarantor';
export const REPAYMENT = '/api/Repayment';
export const Ping_URL = '/api/System/Ping';
export const Sale_URL = '/api/Sale';
export const TRADE_URL = '/api/Trade';
export const BANNER_URL = '/api/Banner';
export const Payment_URL = '/api/Payment';
export const APPNOTICE = '/api/AppNotice';
export const ADDITIONALFIELDS = '/api/AdditionalFields';
export const SALARYDEDUCTION = '/api/SalaryDeduction';
//chace for api==============
export const BASIC_INFORMATION_URL = '/api/BasicInformation';
export const IDENTITY_URL = '/api/Identity';
//cache for login and auth
export const MOBILE = 'mobile';
export const NATIONAL_CODE = 'nationalCode';
export const REF_OTP = 'refOtp';
export const TIME_OTP = 'timeOtp';
export const OTP_lENGTH = 'otpLength';
//cache for login and auth

//Kyc subdomain
export const KYC_URL = '/api/Kyc';

//customerContract subdomain
export const CUSTOMER_CONTRACT_URL = '/api/CustomerContract';
//cache for refrenceKey
export const REFRENCE_KEY = 'refrencekey';

//cache for recident
export const RESIDENT_DOCUMENT_TYPE = 'residentdocumentType';
//cache for documentTyps
export const DOCUMENT_TYPES = 'documnetTypes';
// cache information loan
export const LOAN_CARD_INFO = 'loanCardInfo';
// cache inquiry
export const INQUIRY_REQUIRED_OTP = 'inquiryRequiredOtp';
export const INQUIRY_RESULT = 'inquiryResult';
// cache guarantor
export const GUARANTOR_REQUIRED_OTP = 'guarantorRequiredOtp';
export const GUARANTOR_RESULT = 'guarantorResult';
export const GUARANTOR_MOBILE = 'guarantormobile';
export const GUARANTOR_INFO = 'guarantorInfo';
// store subdomain
export const STORE_URL = '/api/Store'

export const INCOME_RANGE = 'incomeRange';
export const INCOME_RANGE_JOB = 'incomeRangeJob';
// customer info subdomain
export const CUSTOMER_INFO = '/api/Customer'

export const UUID = uuid();
//wallet subdomain
export const WALLET_URL = '/api/Wallet'

export const WALLET_KEY = 'walletKey';

export const SALE_ID = 'saleId'
//loans
export const REPAYMENT_TYPE = 'repaymentType'
export const PAYMENT_VALUE = 'paymentValue'
export const LOANS_INFO = 'loansInfo'

//payment
export const PAYMENT_ID = 'paymentId'
export const GATEWAY_PAYMENT_TOKEN = 'gatewayPaymentToken';

//external route external provider
export const EXTERNAL_PROVIDE = 'externalProvider';
export const EXTERNAL_PROVIDE_TOKEN = 'externalProviderToken';

// adtrace event tokens
export const ADTRACE_EVENT_TOKEN_STORE = 'o1odrj';
export const ADTRACE_EVENT_TOKEN_SUBMIT_LOAN_REQUEST = '4r6czn';

